<template>
    <div class="home">
        <div v-if="!pageLoading">
<!--            <heading text="Search our Volkswagen Group vehicles to see the best small business leasing options"></heading>-->
            <search-filter></search-filter>
<!--            <carousel-cards v-if="initialState" :offers="specialOffers" :type="filterType"></carousel-cards>-->
            <list v-if="!initialState"></list>
            <disclaimer :cms-text="disclaimer" :additionalDynamic="true"></disclaimer>
        </div>
        <loader v-else></loader>
    </div>
</template>

<script>
    import CarouselCards from '@/components/CarouselCards'
    import List from '@/components/List'
    import SearchFilter from "@/components/SearchFilter";
    import Heading from "../components/Heading";
    import Disclaimer from "../components/Disclaimer";
    import {GET_BODY, GET_DISCLAIMER, GET_OFFERS_FULL} from "../store/action-types";
    import Loader from "../components/Loader";
    import {FILTER_TYPE, RESET} from "../store/mutation-types";

    export default {
        name: 'home',

        components: {
            Loader,
            Disclaimer,
            Heading,
            SearchFilter,
            CarouselCards,
            List
        },
        data: function() {
            return {
                disclaimerId: 1,
                busyBody: true,
                pageLoading: true,
                itemsPerPage: 9,
                currentPage: 1,
                order: 'finance-asc',
            }
        },
        computed: {
            disclaimer: function() {
                return this.$store.state.CMS_DISCLAIMER;
            },
            initialState: function() {
                return (this.$store.state.STATE === 0);
            },
            specialOffers: function() {
                return this.$store.state.OFFERS_FULL;
            },
            filterType: {
                get: function() {
                    return this.$store.state.FILTER_TYPE;
                },
                set: function(value) {
                    this.$store.commit(FILTER_TYPE, value);
                }
            }
        },
        methods: {
            getDisclaimer: async function(initialState) {
                await this.$store.dispatch(GET_DISCLAIMER, this.disclaimerId)
                if (!initialState) {
                    this.pageLoading = false;
                }
            },
            getOffers: function(type) {
                type = typeof type === 'undefined' ? this.filterType : type;
                this.$store.dispatch(GET_OFFERS_FULL,{data: {limit:this.itemsPerPage, page:this.currentPage, order:this.order, type: type, manufacturer: this.$store.state.FILTER_MANUFACTURER}});
            },
            getBodyStyles: function() {
                let app = this;
                this.$store.dispatch(GET_BODY, function() {
                    app.busyBody = false;
                    app.pageLoading = false;
                });
            },
        },
        watch: {
            initialState: function(value) {
                this.disclaimerId = (value) ? 1 : 3;
                this.getDisclaimer(true);
            },
            filterType: function(value) {
                this.getOffers(value);
            }
        },
        created: function(){
            this.pageLoading = true;
            let reset = localStorage.getItem('RESET');
            if (reset === 'true') {
                this.$store.commit(RESET);
                localStorage.removeItem('RESET');
            }
            if (this.initialState) {
                this.getOffers();
                this.getBodyStyles();
            }
            this.getDisclaimer(this.initialState);
            this.$tracking.logPageLoad('SME-Price-List:Home');

        },
        beforeRouteEnter(to, from, next) {
            if (from.name === null && performance.navigation.type !== 1) {
                localStorage.setItem('RESET', 'true');
                localStorage.removeItem('sme-direct-price-list');
            }
            next();
        },
    }
</script>

<style scoped lang="stylus">
    .home
        ::v-deep h2
            margin-top 0
</style>
